<template>
  <div class="login">
    <p class="loginTitle">{{ title }}</p>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div class="title">重置密码</div>
      <el-form-item label prop="telNo">
        <el-input
          v-if="flag1"
          v-model="ruleForm.telNo"
          placeholder="联系人手机号"
          inputblur="inputblur"
        ></el-input>
        <el-input
          v-else
          v-model="ruleForm.telNo"
          placeholder="联系人手机号"
          @blur="getTel()"
        ></el-input>
      </el-form-item>
      <el-form-item label prop="imageCode">
        <el-input
          v-if="flag2"
          class="code_txt"
          v-model="ruleForm.imageCode"
          placeholder="图形验证码"
          inputblur="inputblur"
        ></el-input>
        <el-input
          v-else
          class="code_txt"
          v-model="ruleForm.imageCode"
          placeholder="图形验证码"
          @blur="getImagecode()"
        ></el-input>
        <div class="img_code" @click="refreshCode">
          <img :src="img" alt />
        </div>
      </el-form-item>
      <el-form-item label prop="telCode">
        <el-input
          v-if="flag3"
          class="code_txt"
          v-model="ruleForm.telCode"
          placeholder="手机验证码"
          inputblur="inputblur"
        ></el-input>
        <el-input
          v-else
          class="code_txt"
          v-model="ruleForm.telCode"
          placeholder="手机验证码"
          @blur="getTelcodes()"
        ></el-input>
        <div class="phone_code" @click="disabledButton" v-if="isShow">
          <el-button :disabled="disabled">
            <span>发送验证码</span>
          </el-button>
        </div>
        <div class="phone_code1" v-else>
          <el-button :disabled="disabled">
            <span>{{ timeNum }}</span>
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label prop="newPwd">
        <el-input
          v-if="flag4"
          v-model="ruleForm.newPwd"
          type="password"
          placeholder="新密码"
          inputblur="inputblur"
        ></el-input>
        <el-input
          v-else
          v-model="ruleForm.newPwd"
          type="password"
          placeholder="新密码"
          @blur="getNewpwd()"
        ></el-input>
      </el-form-item>
      <el-form-item class="sub_button">
        <el-button
          class="button_login"
          type="primary"
          @click="submitForm('ruleForm')"
          >重置密码</el-button
        >
      </el-form-item>
      <el-form-item class="clearfix">
        <div class="registration" @click="resetForm('ruleForm')">取消</div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  // 获取图形验证码
  ApiImagecode,
  // 发送手机验证码
  ApiTelCode,
  // 重置密码
  ApiResetPwd,
} from "@/common/js/api.js";
export default {
  name: "ResetPassword",
  mounted() {
    // 获取图形验证码
    this.getImageCode();
  },
  data() {
    var userphoneRule = (rule, value, callback) => {
      let p =
        /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/;
      if (!value) {
        this.sendCode = false;
        callback(new Error("手机号格式不正确"));
      } else {
        if (p.test(value) == true) {
          this.sendCode = true;
          callback();
        } else {
          this.sendCode = false;
          callback(new Error("手机号格式不正确"));
        }
      }
    };
    return {
      flag1: false,
      flag2: false,
      flag3: false,
      flag4: false,
      img: null,
      timeNum: 60,
      timer: null,
      sendCode: false,
      disabled: false,
      isShow: true,
      ruleForm: {
        telNo: "",
        telCode: "",
        imageCode: "",
        newPwd: "",
      },
      rules: {
        telNo: [{ required: true, validator: userphoneRule, trigger: "blur" }],
        newPwd: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        telCode: [
          { required: true, message: "请输入手机验证码", trigger: "blur" },
        ],
        imageCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { max: 4, message: "长度为4个字符", trigger: "blur" },
        ],
      },
      title: "湘江私募基金管理服务平台",
    };
  },
  methods: {
    getTel() {
      this.flag1 = true;
    },
    getImagecode() {
      this.flag2 = true;
    },
    getTelcodes() {
      this.flag3 = true;
    },
    getNewpwd() {
      this.flag4 = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.onSubmit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async onSubmit() {
      this.ruleForm.newPwd = this.$md5(this.ruleForm.newPwd);
      let res = await ApiResetPwd(this.ruleForm);
      if (res.code == 200) {
        this.$message({
          message: "密码重置成功",
          type: "success",
        });
      }
      this.resetForm("ruleForm");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$router.push({
        path: "/Login",
        query: {
          TownCode: this.$route.query.TownCode,
        },
      });
    },
    disabledButton() {
      if (this.ruleForm.telNo && this.sendCode) {
        this.disabled = true;
        this.isShow = false;
        this.timer = setInterval(() => {
          this.timeNum--;
          if (this.timeNum == 0) {
            this.disabled = false;
            this.isShow = true;
            this.timeNum = 60;
            clearInterval(this.timer);
          }
        }, 1000);

        let data = {
          tel: this.ruleForm.telNo,
        };
        this.getPhoneCode(data);
      }
    },
    getPhoneCode(data) {
      ApiTelCode(data).then((res) => {
        if (res.code == 200) {
          this.ruleForm.telCode = res.result;
        }
      });
    },
    // 刷新验证码
    refreshCode() {
      this.getImageCode();
    },
    // 获取图形验证码
    getImageCode() {
      ApiImagecode({})
        .then((res) => {
          this.img =
            "data:image/png;base64," +
            btoa(
              new Uint8Array(res).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            );
        })
        .catch((res) => {});
    },
  },
  destroyed() {
    if (this.timer) {
      //如果定时器在运行则关闭
      clearInterval(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
.title {
  color: #0f1824;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
  padding: 25px 0;
}
.login {
  form {
    width: 456px;
    // height: 512px;
    border-radius: 16px;
    box-shadow: 3px 5px 7px 4px rgba(0, 0, 0, 0.1);
    padding: 20px 47px;
    position: absolute;
    right: 11.63vw;
    background: #ffffff;
    top: 39vh;
    margin-top: -250px;
  }
  ::v-deep  .el-input__inner {
    height: 46px;
    background: #f5f5f5 !important;
  }
  /* 失去焦点改变背景颜色 */
  ::v-deep  .el-input__inner[inputblur="inputblur"] {
    /* background:#E9F0FD; */
    background: #f5f5f5 !important;
  }
  ::v-deep  .el-form-item__content .button_login {
    width: 100%;
    height: 36px;
    border: 0;
    background: #3099fc;
    border-radius: 6px;
  }
  ::v-deep  .el-form-item__content {
    margin-bottom: 24px;
    margin-left: 0 !important;
  }
  ::v-deep  .sub_button .el-form-item__content {
    margin-bottom: 10px !important;
    margin-top: 14px;
  }
}

.registration {
  font-size: 14px;
  text-align: center;
  color: #b6bcc2;
  cursor: pointer;
}
.code_txt {
  width: calc(100% - 100px - 10px);
}
.img_code {
  cursor: pointer;
  width: 100px;
  float: right;
  margin-top: -11px;
  border: 1px solid #ccc;
}
.phone_code1 ::v-deep  .el-button {
  color: #ccc;
  border: 1px solid #ccc;
}
.phone_code,
.phone_code1 {
  cursor: pointer;
  width: 100px;
  height: 36px;
  line-height: 36px;
  float: right;
  font-size: 14px;
  color: #3165ff;
  ::v-deep  .el-button {
    width: 100%;
    height: 36px;
    padding-left: 0 !important;
    text-align: center;
    padding-right: 0 !important;
    color: #3165ff;
    border-radius: 2px;
    border: 1px solid #3165ff;
  }
}
</style>